import { render, staticRenderFns } from "./Zueri9ClientAndReason.vue?vue&type=template&id=59352a42&"
import script from "./Zueri9ClientAndReason.vue?vue&type=script&lang=js&"
export * from "./Zueri9ClientAndReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports